import styled from "styled-components";

export const StyledCircle = styled("circle")`
  transition: all 0.7s ease-in-out;
`;
